import { Component, OnInit } from "@angular/core";
import { TreeNode } from "@circlon/angular-tree-component";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-manage-config",
	templateUrl: "./manage-config.component.html",
	styleUrls: ["./manage-config.component.scss"]
})
export class ManageConfigComponent implements OnInit {
	public treenodes: any[];
	public selectedItem;
	public oldConfig: string;
	public newConfig: string;

	constructor(public api: ApiService) { }

	ngOnInit() {
		this.UpdateTree();
	}

	public async UpdateTree() {
		const [orgs, configs, assets] = await Promise.all([
			await this.api.GetOrganizations(),
			await this.api.GetAllConfigs(),
			await this.api.GetAllAssets(),
		]);
		for (const org of orgs as any) {
			org.id = "org" + org.organization_id;
			const orgconfigs = configs.filter(item => item.organization_id === org.organization_id);
			org.children = orgconfigs;
			for (const config of orgconfigs as any) {
				config.id = "cfg" + config.asset_type_id;
				config.name = config.asset_type_name;
				config.assets = assets.filter(item => item.asset_type_id === config.asset_type_id);
			}
		}
		this.treenodes = orgs;
	}

	public async ActivateNode(node: TreeNode) {
		this.selectedItem = undefined;
		this.oldConfig = undefined;
		this.newConfig = undefined;
		node.expand();
		if (node.id.startsWith("cfg")) {
			this.selectedItem = node.data;
			this.oldConfig = await this.api.GetConfigContent(this.selectedItem.asset_type_id);
		}
	}

	public DuplicateConfig() {
		this.newConfig = this.oldConfig;
	}

	public async DeleteConfig() {
		await this.api.DeleteConfig(this.selectedItem.asset_type_id);
		await this.UpdateTree();
		this.selectedItem = undefined;
	}

	async UpdateConfig() {
		await this.api.UpdateConfig(this.selectedItem.asset_type_id, this.newConfig);
		this.oldConfig = await this.api.GetConfigContent(this.selectedItem.asset_type_id);
	}
}
